import React from 'react';

export const LeagueSignUpPage = () => (
    <div className="space-y-8 text-left">
        <div className="space-y-3">
            <h2 className="page-title heading-primary-1 mb-0">League Sign-Up Details</h2>
            <div className="flex flex-wrap justify-center gap-2">
                <span className="tag tag-outline tag-primary-one">Spring</span>
                <span className="tag tag-outline tag-success">Fall</span>
                <span className="tag tag-outline tag-info">21+</span>
                <span className="tag tag-outline tag-warning">Tuesday Nights</span>
            </div>
        </div>

        {/* Intro */}
        <div className="card rounded-lg p-6">
            <p className="text-lg leading-relaxed text-strong">
                Welcome to the Sign-up details for Chico Dart League!
            </p>
            <div className="mt-4 grid gap-4 md:grid-cols-2">
                <div className="card border-left-secondary-4 bg-secondary-soft rounded-lg p-4 shadow-sm">
                    <p>
                        We have both <strong className="font-bold">Spring</strong> and <strong className="font-bold">Fall</strong> seasons each year.
                    </p>
                    <ul className="list-disc list-inside ml-4 mt-2">
                        <li>Only each team’s captain needs to complete a form.</li>
                        <li>Individual forms accepted for players seeking a team.</li>
                    </ul>
                </div>
                <div className="card border-left-info-4 bg-info-soft rounded-lg p-4 shadow-sm">
                    <p>
                        The <strong className="font-bold">Chico Area Dart Association</strong> is open to all players ages 21 and up!
                    </p>
                    <p className="mt-2">
                        To join, your team must have availability to participate on
                        <strong className="font-bold"> Tuesday nights at 7:00PM up to 10:00PM during the season</strong>.
                        Match time may vary based on player performances and leg count.
                    </p>
                </div>
            </div>
        </div>

        {/* Tuesday Format */}
        <section className="card rounded-lg shadow-sm overflow-hidden">
            <div className="accent-gradient-bar h-1" />
            <div className="p-6 max-w-6xl mx-auto">
                <h3 className="text-2xl font-semibold heading-primary-1 text-center">Tuesday Match Format</h3>
                <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {[
                        'Game 1: 301 Singles',
                        'Game 2: 301 Singles',
                        'Game 3: 301 Doubles',
                        'Game 4: 501 Singles',
                        'Game 5: 501 Singles',
                        'Game 6: 501 Doubles',
                        'Game 7: Cricket Singles',
                        'Game 8: Cricket Singles',
                        'Game 9: Cricket Doubles',
                    ].map((line) => (
                        <div key={line} className="rounded-md surface-low hover-accent-border px-3 py-2 text-sm text-center">
                            {line}
                        </div>
                    ))}
                </div>
                <ul className="list-disc list-inside my-4 bg-primary-soft rounded-lg p-4">
                    <li><span className="font-bold">All Games are Best of 3 Legs</span></li>
                    <li><span className="font-bold">Playoffs Seeded by Game Points (Wins)</span></li>
                    <li><span className="font-bold">Match win tiebreaker</span></li>
                </ul>
                <p className="text-muted text-center">
                    Each season also includes a <strong className="font-bold">Mid-Season Singles Shoot</strong> (runs late) and an
                    <strong className="font-bold"> End of Season Party Shoot</strong> (blind draw) with league sponsored food and drinks! (free pitchers)
                </p>
            </div>
        </section>

        {/* Important callout */}
        <div className="rounded-lg bg-warning-soft border-l-4 border-warning p-6">
            <h4 className="text-xl font-bold heading-primary-1">
                <span className="label label-warning">Important</span>
            </h4>
            <p className="mt-2">
                In the event of a planned or unplanned absence, you <strong className="font-bold">must</strong> promptly contact the scheduled opponent and
                <strong className="font-bold"> give as much advanced notice as possible.</strong> It is best to reschedule known make-up games prior to their scheduled date if possible!
                Substitute players may be available — please be flexible and courteous. Failure to reschedule may result in a 0-9 forfeit to the opposing team.
            </p>
        </div>

        {/* Info callout */}
        <div className="rounded-lg bg-info-soft border-l-4 border-info p-6">
            <h4 className="text-xl font-bold heading-primary-1">
                <span className="label label-info">Info</span>
            </h4>
            <p className="mt-2">
                Season schedule, match statistics and game highlights are recorded and displayed on our <strong className="font-bold">Premium YLS Site</strong>
                for players to view throughout the season! All matches must be legibly recorded and reported to the league on C.A.D.A. scorecards to be applicable for weekly updates!
            </p>
            <ul className="list-disc list-inside ml-4 mt-3">
                <li>
                    C.A.D.A. does <strong className="font-bold">not</strong> currently run league matches through DartConnect’s paid scheduling software
                    <span className="block text-sm text-muted">(Free tier DC memberships will not be granted access to scorekeeping feature)</span>
                </li>
                <li>C.A.D.A. does <strong className="font-bold">not</strong> currently retain an ADO membership (just for fun)</li>
                <li>
                    C.A.D.A. does <strong className="font-bold">receive a discount on bulk orders from A-Z Darts!</strong>
                    <span className="block text-sm text-muted">(More details and the order form can be found here)</span>
                </li>
            </ul>
            <p className="mt-3">
                While many teams have at least one player with a Tablet + DartConnect Premium, you may not always be able to rely on a digital scoreboard.
                Our <strong className="font-bold">recommendation</strong> for the smoothest experience is to bring a tablet and create a <strong className="font-bold">DartConnect Premium</strong> account.
                DC+ costs <strong className="font-bold">$24/year</strong> and is not associated with our league.
                <span className="block text-sm text-muted">(Quackers home teams are required to have tablets; the Down Lo has chalkboards if no tablet is available)</span>
            </p>
        </div>

        {/* Requirements / Recommendations / Provided */}
        <section>
            <h4 className="text-2xl font-semibold heading-primary-1 text-center">What do I need?</h4>
            <div className="mt-4 grid gap-4 md:grid-cols-3">
                <div className="card rounded-lg border-left-warning-4 p-4 shadow-sm">
                    <h5 className="font-bold heading-primary-1">
                        <span className="label label-warning">Requirements</span>
                    </h5>
                    <ol className="list-decimal list-inside ml-4 mt-2 space-y-1">
                        <li>Steep tip darts</li>
                        <li>A team of 2–3 players (must have at least 2 each night)</li>
                        <li>Availability to play Tuesday Nights (Spring or Fall)</li>
                        <li>Commitment to complete full season of scheduled matches</li>
                        <li>Positive attitude and desire to play</li>
                    </ol>
                </div>
                <div className="card rounded-lg border-left-info-4 p-4 shadow-sm">
                    <h5 className="font-bold heading-primary-1">
                        <span className="label label-info">Recommendations</span>
                    </h5>
                    <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                        <li>Extra equipment (flights & shafts)
                            <span className="block text-sm text-muted">Note: Damage may occur during play!</span>
                        </li>
                        <li>Tablet + DartConnect Premium</li>
                    </ul>
                </div>
                <div className="card rounded-lg border-left-success-4 p-4 shadow-sm">
                    <h5 className="font-bold heading-primary-1">
                        <span className="label label-success">Provided</span>
                    </h5>
                    <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                        <li>Winmau Blade Series Dartboards (League Use Only)</li>
                        <li>Schedule, Match Statistics and Highlight Tracking (YLS)</li>
                        <li>League Party Concessions</li>
                    </ul>
                </div>
            </div>
        </section>

        {/* When / Where / Team / Dues */}
        <section className="grid gap-4 sm:grid-cols-2">
            <div className="card border-left-accent-4 rounded-lg p-4">
                <h6 className="font-bold heading-primary-1">
                    <span className="label label-primary">When</span>
                </h6>
                <p className="mt-1">Tuesday Nights 7-10PM (Spring & Fall Seasons)</p>
            </div>
            <div className="card border-left-info-4 rounded-lg p-4">
                <h6 className="font-bold heading-primary-1">
                    <span className="label label-info">Where</span>
                </h6>
                <p className="mt-1">The Down Lo & Quackers</p>
            </div>
            <div className="card border-left-success-4 rounded-lg p-4">
                <h6 className="font-bold heading-primary-1">
                    <span className="label label-success">Team Size</span>
                </h6>
                <p className="mt-1">2-3 Players</p>
            </div>
            <div className="card border-left-warning-4 rounded-lg p-4">
                <h6 className="font-bold heading-primary-1">
                    <span className="label label-warning">League Dues</span>
                </h6>
                <p className="mt-1">$40/Player</p>
            </div>
        </section>

        {/* Etiquette */}
        <div className="rounded-lg bg-primary-soft border-l-4 border-primary p-6">
            <h4 className="text-xl font-bold heading-primary-1">
                <span className="label label-primary">Etiquette</span>
            </h4>
            <p className="mt-2 text-strong leading-relaxed">
                We ask that all players be respectful at all times, act appropriately at league venues and maintain proper match etiquette while playing on league equipment against other teams!
            </p>
        </div>

        {/* Contact + Closing */}
        <div className="card rounded-lg border-left-success-4 p-6">
            <p>
                Any questions about the league play, signing-up or league orders please contact
                {' '}
                <strong className="font-bold">chicodarts530@gmail.com</strong>
            </p>
            <p className="mt-3 font-semibold text-success">We hope to see you on the oche!</p>
            <p className="text-muted">–Chico Darts</p>
        </div>
    </div>
);